export const baseURL = "https://daycare.thewebtestlink.xyz/api/v1";
// export const baseURL = "http://localhost:3000/api/v1";
export const imgUrl = "https://daycare.thewebtestlink.xyz/";
